<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  },
  methods: {
    renderChart (data, options) {
      const self = this
      const baseOptions = options || this.options || {}
      const userOnClick = baseOptions.onClick

      const wrappedOptions = Object.assign({}, baseOptions, {
        onClick (evt, activeEls) {
          let points = []
          try {
            const chart = self.$data && self.$data._chart ? self.$data._chart : null
            if (chart && typeof chart.getElementsAtEventForMode === 'function') {
              points = chart.getElementsAtEventForMode(evt, 'nearest', { intersect: true }, false)
            }

            if (!points.length && activeEls && activeEls.length) {
              points = activeEls
            }

            if (!points.length && chart && typeof chart.getElementsAtEvent === 'function') {
              points = chart.getElementsAtEvent(evt)
            }

            if (points && points.length) {
              const p = points[0]
              self.$emit('bar-click', { datasetIndex: p._datasetIndex, index: p._index })
            }
          } finally {
            if (typeof userOnClick === 'function') {
              userOnClick(evt, activeEls)
            }
          }
        }
      })

      // @ts-ignore
      const superRenderChart = this.$options.extends.methods.renderChart
      superRenderChart.call(this, data, wrappedOptions)
    }
  }
}
</script>
